
export interface TLFRProps {
  name?: string;
  patente?: string;
  activo?: boolean;
  tipoModulo?: number[];
}

export const getTrucksFilter = (data: TLFRProps) => {
  return {
    ...(data?.name
      ? {
          nombre: data?.name,
        }
      : {}),
    ...(data?.patente
      ? {
          patente: data?.patente,
        }
      : {}),
    ...(data?.activo ? { activo: data?.activo } : {}),
    ...(data?.tipoModulo?.length ? { tipoModulo: data?.tipoModulo } : {}),
  };
};
